import { createContext, useContext, useState, useMemo } from "react";
import { trackDialogOpen } from "@/lib/analytics";

const StudioContext = createContext(null);
export const useStudio = () => useContext(StudioContext);

export function StudioProvider({ children }) {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [sampleOpen, setSampleOpen] = useState(false);
  const value = useMemo(
    () => ({
      bookingOpen,
      sampleOpen,
      setBookingOpen,
      setSampleOpen,
      openBooking: () => {
        trackDialogOpen("booking");
        setBookingOpen(true);
      },
      openSample: () => {
        trackDialogOpen("sample");
        setSampleOpen(true);
      },
    }),
    [bookingOpen, sampleOpen]
  );
  return <StudioContext.Provider value={value}>{children}</StudioContext.Provider>;
}
